import React, { ComponentProps } from 'react';
import { SearchResults } from '../../types/Search.types';
import { Pagination, PaginationItemWithPageLink } from '../../_lib/components/Pagination';
import { asBlock, useBlockContext } from '../../_lib/BlockFetcher';
import { SearchForm } from './partials/SearchForm';
import { BlockType } from '../../types/api/ElementType';
import { FACETS } from '../../components/molecules/ResultListSettings/ResultListSettings.enums';
import UserSearchResults from '../../components/blocks/SearchResults/UserSearchResults/UserSearchResults';

type UserSearchProps = SearchResults & {
  pageItems?: PaginationItemWithPageLink[];
};

const userSearchFacets = [FACETS.FQ_PROFILE_FIELDS];

export function UserSearch({ pageItems, ...embedded }: UserSearchProps) {
  const { blockLayout } = useBlockContext();

  return (
    <>
      <SearchForm type="user" showSwitchButtons wantedFacets={userSearchFacets} searchResult={embedded} />
      {embedded && embedded.resultUsers ? (
        <UserSearchResults blockLayout={blockLayout || 'large'} resultUsers={embedded.resultUsers} />
      ) : null}
      <Pagination pageItems={pageItems} />
    </>
  );
}

type UserSearchTypes = BlockType.usersearch;
export const UserSearchBlock = asBlock<UserSearchProps, UserSearchTypes>(UserSearch);
export type UserSearchBlock = ComponentProps<typeof UserSearchBlock>;
